import React from 'react';
import { SEO, faqSchema } from '../components/SEO';
import { Hero } from '../components/Hero';
import { TrustSignals } from '../components/TrustSignals';
import { ServicesOverview } from '../components/ServicesOverview';
import { GoogleReviews } from '../components/GoogleReviews';
import { ReferencesTeaser } from '../components/ReferencesTeaser';
import { TeamTeaser } from '../components/TeamTeaser';
import { ContactTeaser } from '../components/ContactTeaser';

export default function HomePage() {
  return (
    <main data-testid="home-page">
      <SEO
        path="/"
        description="BENI Gipsergeschäft GmbH in Aesch – Professionelle Gipserarbeiten, Malerarbeiten, Trockenbau, Aussenfassaden und Innenausbau. Umbau, Neubau, Sanierungen in der Region Basel. Jetzt kostenlose Offerte anfordern!"
        keywords="Gipser Aesch, Maler Basel, Trockenbau Basel-Landschaft, Gipserarbeiten Aesch, Malerarbeiten Basel, Fassadenarbeiten Aesch, Innenausbau Basel, Sanierung Basel-Landschaft, Umbau Aesch, Neubau Gipser Basel, Verputzarbeiten Aesch, Stuckarbeiten Basel, BENI Gipsergeschäft GmbH, Gipser Reinach, Gipser Münchenstein, Gipser Muttenz, Gipser Binningen, Gipser Oberwil, Gipser Therwil, Gipser Allschwil, Gipser Laufen, Handwerker Aesch, Maler Reinach BL, Fassadensanierung Basel"
        schema={faqSchema}
      />
      <Hero />
      <TrustSignals />
      <ServicesOverview />
      <GoogleReviews />
      <ReferencesTeaser />
      <TeamTeaser />
      <ContactTeaser />
    </main>
  );
}
